import { render, staticRenderFns } from "./booking-detail-header.vue?vue&type=template&id=2b5de987&scoped=true&"
import script from "./booking-detail-header.vue?vue&type=script&lang=js&"
export * from "./booking-detail-header.vue?vue&type=script&lang=js&"
import style0 from "./booking-detail-header.vue?vue&type=style&index=0&id=2b5de987&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5de987",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
